module.exports = __webpack_public_path__ + "img/home-mobile-min.8b4b3822.png";